import { render, staticRenderFns } from "./PrintingPaper.vue?vue&type=template&id=2e297248"
import script from "./PrintingPaper.vue?vue&type=script&lang=js"
export * from "./PrintingPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports